import "./style.scss";

import { Space, Tag, Tooltip } from "antd";
import { StarFilled } from "@ant-design/icons";

// const styleWrapperClass = "floatingCard";

export default function FeatureTag({
  type,
  isClickable,
  cursor,
  style,
  useDarkBackground,
  tooltipTitle,
}) {
  // const navigate = useNavigate();

  if (!!!isClickable) {
    isClickable = false;
  }

  if (!!!cursor) {
    cursor = "default";
  }

  const styleBackgroundGradient = {
    background: "linear-gradient(135deg, #FFE8FC 20%, #E2F7FF)",
    color: "#1C5676",
  };

  let color, displayName, styleInternal;
  if (type === "new_feature") {
    // color = "gold";
    styleInternal = !!!useDarkBackground
      ? styleBackgroundGradient
      : {
          background: "#1C5676",
          border: "0px",
          color: "white",
        };
    displayName = <>Nuevo</>;
  } else if (type === "coming_soon_feature") {
    color = "blue";
    displayName = "Próximanente";
  } else if (type === "founder_badge") {
    styleInternal = styleBackgroundGradient;
    displayName = <StarFilled />;
  } else if (type === "feature_preview") {
    styleInternal = styleBackgroundGradient;
    displayName = "Nuevo (Acceso Prioritario)";
  } else {
    color = "gray";
    displayName = "N/A";
  }

  styleInternal = {
    cursor: cursor,
    fontWeight: "normal",
    ...styleInternal,
    ...style,
  };

  return (
    <Tooltip title={tooltipTitle}>
      <Tag
        color={color}
        // onClick={() => (isClickable ? navigate("/plan") : null)}
        style={styleInternal}
      >
        <Space>{displayName}</Space>
      </Tag>
    </Tooltip>
  );
}
